<main
  class="funnel-main"
  [ngClass]="{ 'activate-theme': isActivateRedirect() }"
>
  <!-- Coupon banner disabled -->
  <!-- <flo-coupon-status [couponHasBeenApplied]="isCouponApplied$ | async"></flo-coupon-status> -->
  <section>
    <router-outlet></router-outlet>
  </section>
</main>
